var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group", class: { "input-group": _vm.hasIcon } },
    [
      _vm._t("label", function() {
        return [
          _vm.label
            ? _c(
                "label",
                { staticClass: "control-label", attrs: { for: _vm.cusName } },
                [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _vm._t("addonLeft", function() {
        return [
          _vm.addonLeftIcon
            ? _c("span", { staticClass: "input-group-addon" }, [
                _c("i", { class: _vm.addonLeftIcon })
              ])
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "textarea",
        _vm._b(
          {
            staticClass: "form-control",
            class: {
              "is-invalid": _vm.hasErrors && _vm.hasErrors.has(_vm.cusName),
              "is-valid": _vm.isInputValid()
            },
            staticStyle: { height: "100%" },
            attrs: {
              rows: _vm.rows,
              cols: _vm.cols,
              "aria-describedby": "addon-right addon-left",
              autocomplete: "off",
              id: _vm.cusName,
              name: _vm.cusName
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.inputEvent("input", $event.target.value)
              },
              blur: function($event) {
                return _vm.inputEvent("input", $event.target.value)
              }
            }
          },
          "textarea",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm._t("addonRight", function() {
        return [
          _vm.addonRightIcon
            ? _c("span", { staticClass: "input-group-addon" }, [
                _c("i", { class: _vm.addonRightIcon })
              ])
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasErrors && _vm.hasErrors.has(_vm.cusName),
              expression: "hasErrors && hasErrors.has(cusName)"
            }
          ],
          staticClass: "invalid-feedback"
        },
        [_vm._v(_vm._s(_vm.hasErrors && _vm.hasErrors.first(_vm.cusName)))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-358d1c98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-358d1c98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Inputs/formGrouptextArea.vue
// module id = nUTi
// module chunks = 0